import React, { useContext,  useState } from 'react';
// import { FaArrowRightLong } from 'react-icons/fa6';
// import { FaArrowLeftLong } from 'react-icons/fa6';
import { FormContext } from './Provider';
import { useNavigate } from 'react-router-dom';


const AcademicInfo = ({ step, setStep }) => {


    const { academicInfo, setAcademicInfo } = useContext(FormContext)
    const [error, setError] = useState({ instituteName: 0, courseName: 0, deptName: 0, passout: 0, location: 0 });


    const navigate = useNavigate();
    const validationCheck = () => {
        let _error = { ...error };

        let nextStep = true;
        Object.keys(academicInfo).forEach((item) => {
            if (academicInfo[item] === "" && item !== "isGoing") {
                _error[item] = 1;
                nextStep = false;

            } else {
                _error[item] = 0;

            }
        });
        setError(_error);

        if (nextStep) {
            navigate('/admission-form');
            setStep(step + 1);
        }

    };

    const validateYear = (year) => {
        if (year <= 3000) {
            setAcademicInfo({ ...academicInfo, passout: year });
            if (error.passout === 1 && year !== "") {
                setError({ ...error, passout: 0 });
            }
        }
    };

    return (
        <div className=" pt-3">
            <div className="bg-white rounded-lg shadow-md p-7">
                <div className=" bg-gray-100 px-4  container py-5 h-100 flex justify-center items-start">
                    <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                        <div className="font-bold text-lg text-primary-800">Academic Details</div>
                        <div className="pt-2 text-gray-700">Please provide your academic information</div>

                        <div className="flex flex-col gap-6 mt-6">
                            {/* First Row: Institute & Department */}
                            <div className="flex flex-col md:flex-row gap-6">
                                {/* Institute */}
                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="institute"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={academicInfo.instituteName}
                                        onChange={(e) => {
                                            setAcademicInfo({ ...academicInfo, instituteName: e.target.value });
                                            if (error.instituteName && e.target.value !== "") {
                                                setError({ ...error, instituteName: 0 });
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor="institute"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[3rem] scale-75  peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75 peer-focus:text-blue-600"
                                    >
                                        Institute Name <span className='text-red-600 text-lg'> *</span>
                                    </label>
                                    <span className="text-red-500 text-xs  block">{error.instituteName ? "Institution Name is Required" : ""}</span>
                                </div>
                                
                                {/* Course */}
                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="course"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={academicInfo.courseName}
                                        onChange={(e) => {
                                            setAcademicInfo({ ...academicInfo, courseName: e.target.value });
                                            if (error.courseName && e.target.value !== "") {
                                                setError({ ...error, courseName: 0 });
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor="course"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[3rem] scale-75  peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2  peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Course Name <span className='text-red-600 text-lg'> *</span>
                                    </label>
                                    <span className="text-red-500 text-xs h-4 block">{error.courseName ? "Course Name is Required" : ""}</span>
                                </div>
                            </div>

                            {/* Second Row: Course & Year */}
                            <div className="flex flex-col md:flex-row gap-6">
                               
                                {/* Department */}
                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="dept"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={academicInfo.deptName}
                                        onChange={(e) => {
                                            setAcademicInfo({ ...academicInfo, deptName: e.target.value });
                                            if (error.deptName && e.target.value !== "") {
                                                setError({ ...error, deptName: 0 });
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor="dept"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[3rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2  peer-placeholder-shown:scale-100 peer-focus:top-1/2   peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Department Name <span className='text-red-600 text-lg'> *</span>
                                    </label>
                                    <span className="text-red-500 text-xs h-4 block">{error.deptName ? "Department Name is Required" : ""}</span>
                                </div>

                                {/* Year */}
                                <div className="relative w-full  md:w-1/2">
                                    <input
                                        type="Number"
                                        id="passout"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={academicInfo.passout}
                                        onChange={(e) => validateYear(e.target.value)}
                                    />
                                    <label
                                        htmlFor="passout"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[3rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Year of Passout <span className='text-red-600 text-lg'> *</span>
                                    </label>
                                    <span className="text-red-500 text-xs h-4 block">{error.passout ? "Year of passout is Required" : ""}</span>
                                </div>
                            </div>

                            {/* Currently Studying Checkbox */}


                            {/* Location */}
                            <div className="relative w-full md:w-1/2">
                                <input
                                    type="text"
                                    id="location"
                                    placeholder=" "
                                    className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={academicInfo.location}
                                    onChange={(e) => {
                                        setAcademicInfo({ ...academicInfo, location: e.target.value });
                                        if (error.location && e.target.value !== "") {
                                            setError({ ...error, location: 0 });
                                        }
                                    }}
                                />
                                <label
                                    htmlFor="location"
                                    className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                >
                                    Location <span className='text-red-600 text-lg'> *</span>
                                </label>
                                <span className="text-red-500 text-xs h-4">{error.location ? "Location is Required" : ""}</span>
                            </div>

                            {/* Buttons */}
                            <div className="flex flex-row sm:flex-row justify-between items-center gap-4 mt-6">
                                <button
                                    className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded"
                                    onClick={() => {
                                        navigate('/admission-form')
                                        setStep(step - 1)
                                    }}
                                >
                                    {/* <FaArrowLeftLong /> */}
                                    Back
                                </button>

                                <button
                                    className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded"
                                    onClick={validationCheck}
                                >
                                    Next
                                    {/* <FaArrowRightLong /> */}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcademicInfo;


